import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, trackCheckout } from '../utils/checkout';
import { alsoIncluded, bonusList, mainSystem } from '../data/packageIncludes';
import { questionsAnswered } from '../data/scenarios';
const releases = ['No more endless searching for another drill', 'No more wondering what progression should come next', 'No more using the same activities because you ran out of ideas', 'No more rebuilding an entire lesson because the group changed', 'No more finishing your workday only to start planning tomorrow’s sessions'];
const flow = ['Choose the objective', 'Open the system', 'Select the lesson', 'Adapt the level', 'Teach', 'Assess', 'Progress'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-ivory" data-id="element-98" data-mp="14uoeyf8tro6g">
      <div className="max-w-4xl mx-auto" data-id="element-99" data-mp="14vptwusyoutg">
        <div className="text-center mb-16" data-id="element-100" data-mp="zwv9jofciy78">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-navy" data-id="element-101" data-mp="zxxwxmdgmiie">
            Next Week You Could Still Be Planning Every Lesson From Scratch...
            <br data-id="element-102" data-mp="2h4sqkjci3vuu" />
            <span className="text-gold-dark" data-id="element-103" data-mp="2h49irvgkenuj">
              Or you could arrive at the pool already knowing what you are going to teach.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-10 bg-pearl-light p-8 rounded-2xl border border-pearl-dark" data-id="element-104" data-mp="2r2752dev6aki">
            {releases.map(item => <div key={item} className="flex items-start gap-3" data-id="element-105" data-mp="302lsbibe1zqn">
                <span className="text-gold-dark mt-1" aria-hidden="true" data-id="element-106" data-mp="300sp6czzhxne">
                  ▸
                </span>
                <span className="text-graphite" data-id="element-107" data-mp="34vogtc1b6izz">{item}</span>
              </div>)}
          </div>

          <ol className="flex flex-wrap justify-center gap-x-3 gap-y-2 mb-12" data-id="element-108" data-mp="3eri2pm0x3ouf">
            {flow.map(step => <li key={step} className="text-sm font-semibold text-navy bg-aqua-light border border-aqua/30 rounded-full px-4 py-1.5" data-id="element-109" data-mp="3islffzno54rf">
                {step}
              </li>)}
          </ol>

          <h3 className="text-2xl md:text-3xl font-serif font-bold text-navy mb-4" data-id="element-110" data-mp="1er3bp75p14cx">
            You Don’t Need More Random Information
          </h3>
          <p className="text-lg text-graphite mb-8 max-w-2xl mx-auto" data-id="element-111" data-mp="1npez70b9jm15">
            You need material that helps you answer the questions that actually matter during
            a swimming lesson:
          </p>
          <ul className="grid sm:grid-cols-2 gap-3 max-w-2xl mx-auto text-left" data-id="element-112" data-mp="1xgjha8w8jn07">
            {questionsAnswered.map(question => <li key={question} className="text-sm text-graphite bg-white border border-pearl-dark rounded-xl px-4 py-3" data-id="element-113" data-mp="2beq32qnwtwji">
                {question}
              </li>)}
          </ul>
        </div>

        <div className="bg-white border-2 border-gold/50 rounded-3xl p-8 md:p-12 shadow-[0_16px_40px_rgba(14,37,71,0.1)]" data-id="element-114" data-mp="d0ohlxv3xs1a">
          <h3 className="text-2xl font-bold text-navy mb-6 text-center border-b border-pearl-dark pb-6" data-id="element-115" data-mp="2x9hhm9l9llj">
            Everything Included in the Complete 6-in-1 System
          </h3>
          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-116" data-mp="3pahpdbdqhex7">
            {[...mainSystem, ...bonusList, ...alsoIncluded].map(item => <div key={item} className="flex items-start gap-3" data-id="element-117" data-mp="3u8atzzze20vd">
                <CheckIcon size={18} className="text-aqua-dark shrink-0 mt-0.5" data-id="element-118" data-mp="3fclcae18k9wg" />
                <span className="text-sm text-graphite" data-id="element-119" data-mp="3kdivmtxzf9zj">{item}</span>
              </div>)}
          </div>
          <div className="text-center" data-id="element-120" data-mp="36e9g7whlojwm">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-gold-dark mb-6" data-id="element-121" data-mp="3bbrsnwutth9d">
              Plan Less. Teach With Confidence. Progress Every Swimmer.
            </p>
            <p className="text-xl font-serif font-bold text-navy mb-2" data-id="element-122" data-mp="14j8sp3bq7a0m">
              Swim Instructor Ready — The Complete 6-in-1 Teaching System
            </p>
            <p className="text-sm text-graphite mb-8 max-w-xl mx-auto" data-id="element-123" data-mp="35mi3cgr4oz4k">
              120 ready-to-teach swimming lessons designed to help instructors spend less
              time planning and more time delivering structured, purposeful swimming lessons.
            </p>
            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-124" data-mp="2robchkkljzee">
              GET SWIM INSTRUCTOR READY TODAY
            </Button>
            <div className="flex flex-wrap justify-center gap-4 text-xs text-graphite" data-id="element-125" data-mp="2hwe1oexi39g7">
              <span data-id="element-126" data-mp="2cznmruxfmjwd">Instant Access</span>
              <span data-id="element-127" data-mp="2cwj6w0altzpv">Secure Payment</span>
              <span data-id="element-128" data-mp="280kgy89mo9nc">7-Day Guarantee</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}